import React, { useRef, useState } from "react";
import dayjs from "dayjs";
import Chat from "./Chat";

const ChatHistory = ({ chats: propChats, users: propUsers, loginUserId: propLoginUserId = 1 }) => {
  // Create a ref for the chat container
  const chatContainerRef = useRef(null);
  const [inputMessage, setInputMessage] = useState("");
  const loginUserId = propLoginUserId;
  const users = propUsers || [
    {
      id: 1,
      name: "Anna Smith",
      profilePhotoUrl: "https://avatars.githubusercontent.com/u/6889093",
    },
    {
      id: 2,
      name: "Sajida Ahmed",
      profilePhotoUrl: "https://avatars.githubusercontent.com/u/34077875",
    },
  ];
   const [chats, setChats] = useState([
    {
      id: 1,
      senderId: 1,

      message: "Hello",
      timestamp: "2023-06-01T10:00:00Z",
    },
    {
      id: 2,
      senderId: 2,
      message: "Hi there!",
      timestamp: "2023-06-01T10:05:00Z",
    },
    {
      id: 3,
      senderId: 1,

      message: "How are you?",
      timestamp: "2024-06-01T10:10:00Z",
    },
    {
      id: 4,
      senderId: 2,
      message: "I'm good, thanks!",
      timestamp: "2024-07-01T10:15:00Z",
    },
    {
      id: 5,
      senderId: 1,

      message: "What are you up to today?",
      timestamp: "2024-07-01T10:20:00Z",
    },
    {
      id: 6,
      senderId: 2,
      message: "Just working on some projects.",
      timestamp: "2024-07-02T10:25:00Z",
    },
    {
      id: 7,
      senderId: 1,

      message: "Sounds interesting. Need any help?",
      timestamp: "2024-07-02T10:30:00Z",
    },
    {
      id: 8,
      senderId: 2,
      message: "Maybe later, I'll let you know.",
      timestamp: "2024-07-03T10:35:00Z",
    },
    {
      id: 9,
      senderId: 1,

      message: "Cool! Let's catch up in the evening?",
      timestamp: "2024-07-03T10:40:00Z",
    },
    {
      id: 10,
      senderId: 2,
      message: "Sure, let's do that.",
      timestamp: "2024-07-03T10:45:00Z",
    },
    {
      id: 11,
      senderId: 1,

      message: "What time works best for you?",
      timestamp: "2024-07-04T10:50:00Z",
    },
    {
      id: 12,
      senderId: 2,
      message: "How about 6 PM?",
      timestamp: "2024-07-04T10:55:00Z",
    },
    {
      id: 13,
      senderId: 1,

      message: "Perfect. See you then!",
      timestamp: "2024-07-04T11:00:00Z",
    },
    {
      id: 14,
      senderId: 2,
      message: "See you!",
      timestamp: "2024-07-04T11:05:00Z",
    },
    {
      id: 15,
      senderId: 1,
      message: "Hey, are you on your way?",
      timestamp: "2024-07-05T17:55:00Z",

      replyTo: {
        messageId: 12,
        message:
          "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard Ipsum has been the industry's standard",
        senderName: "Tektree Software",
        senderId: 2,
      },
    },
    {
      id: 16,
      senderId: 2,
      message:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim.",
      timestamp: "2024-07-05T17:58:00Z",
       reactions: {
        "😮": {
          count: 1,
          reacted: true,
        },
        "❤️": {
          count: 1,
          reacted: true,
        },
      },
    },
  ]);

  // Group chats by date but keep the full timestamp
  const groupChatsByDate = () => {
    const groupedChats = {};

    propChats || chats?.forEach((chat) => {
        const date = dayjs(chat.timestamp).format("YYYY-MM-DD");
      if (!groupedChats[date]) {
        groupedChats[date] = [];
      }
      groupedChats[date].push(chat);
    });

    // Convert to array of date objects with the first message's full timestamp
    return Object.keys(groupedChats)
      .sort((a, b) => dayjs(a).diff(dayjs(b)))
      .map((date) => {
        // Get the first message's full timestamp for each date group
        const fullTimestamp = groupedChats[date][0].timestamp;
        return {
          timestamp: fullTimestamp, // Use the full ISO timestamp
          messages: groupedChats[date],
        };
      });
  };

  const chatsByDate = groupChatsByDate();

  const handleSendMessage = (replyTo) => {
    const trimmed = inputMessage?.trim();
    if (!trimmed) return;

    const newChat = {
      id: chats?.length + 1,
      senderId: loginUserId,
      message: trimmed,
      timestamp: new Date().toISOString(),
      replyTo: replyTo
        ? {
            messageId: replyTo.message?.id,
            message: replyTo.message?.message,
            senderName: replyTo.sender?.name,
          }
        : null,
    };

    setChats((prev) => [...prev, newChat]);
    setInputMessage("");
  };
  const handleDeleteMessage = (messageId) => {
    setChats((prev) => prev.filter((chat) => chat.id !== messageId));
  };
  return (
    <div className="pt-4 overflow-auto h-full">
      <Chat
        chatsByDate={chatsByDate}
        users={users}
        loginUserId={loginUserId}
        showInput={true}
        inputMessage={inputMessage}
        onInputChange={setInputMessage}
        onSendMessage={handleSendMessage}
        loginUserAvatarUrl="https://avatars.githubusercontent.com/u/6889093"
        loginUserAvatarAlt="user"
        onDeleteMessage={handleDeleteMessage}
      />
    </div>
  );
};

export default ChatHistory;

// import React, { useEffect, useRef } from "react";
// import dayjs from "dayjs";
// import Divider from "../Common/Divider";
// import { dateFormator } from "../../utils";
// import Chat from "./Chat";

// const ChatHistory = () => {
//   // Create a ref for the chat container
//   const chatContainerRef = useRef(null);
//   const loginUserId = 1;
//   const users = [
//     {
//       id: 1,
//       name: "Anna Smith",
//       profilePhotoUrl: "https://avatars.githubusercontent.com/u/6889093",
//     },
//     {
//       id: 2,
//       name: "Sajida Ahmed",
//       profilePhotoUrl: "https://avatars.githubusercontent.com/u/34077875",
//     },
//   ];
//   const chats = [
//     {
//       id: 1,
//       senderId: 1,

//       message: "Hello",
//       timestamp: "2023-06-01T10:00:00Z",
//     },
//     {
//       id: 2,
//       senderId: 2,
//       message: "Hi there!",
//       timestamp: "2023-06-01T10:05:00Z",
//     },
//     {
//       id: 3,
//       senderId: 1,

//       message: "How are you?",
//       timestamp: "2024-06-01T10:10:00Z",
//     },
//     {
//       id: 4,
//       senderId: 2,
//       message: "I'm good, thanks!",
//       timestamp: "2024-07-01T10:15:00Z",
//     },
//     {
//       id: 5,
//       senderId: 1,

//       message: "What are you up to today?",
//       timestamp: "2024-07-01T10:20:00Z",
//     },
//     {
//       id: 6,
//       senderId: 2,
//       message: "Just working on some projects.",
//       timestamp: "2024-07-02T10:25:00Z",
//     },
//     {
//       id: 7,
//       senderId: 1,

//       message: "Sounds interesting. Need any help?",
//       timestamp: "2024-07-02T10:30:00Z",
//     },
//     {
//       id: 8,
//       senderId: 2,
//       message: "Maybe later, I'll let you know.",
//       timestamp: "2024-07-03T10:35:00Z",
//     },
//     {
//       id: 9,
//       senderId: 1,

//       message: "Cool! Let's catch up in the evening?",
//       timestamp: "2024-07-03T10:40:00Z",
//     },
//     {
//       id: 10,
//       senderId: 2,
//       message: "Sure, let's do that.",
//       timestamp: "2024-07-03T10:45:00Z",
//     },
//     {
//       id: 11,
//       senderId: 1,

//       message: "What time works best for you?",
//       timestamp: "2024-07-04T10:50:00Z",
//     },
//     {
//       id: 12,
//       senderId: 2,
//       message: "How about 6 PM?",
//       timestamp: "2024-07-04T10:55:00Z",
//     },
//     {
//       id: 13,
//       senderId: 1,

//       message: "Perfect. See you then!",
//       timestamp: "2024-07-04T11:00:00Z",
//     },
//     {
//       id: 14,
//       senderId: 2,
//       message: "See you!",
//       timestamp: "2024-07-04T11:05:00Z",
//     },
//     {
//       id: 15,
//       senderId: 1,
//       message: "Hey, are you on your way?",
//       timestamp: "2024-07-05T17:55:00Z",
//     },
//     {
//       id: 16,
//       senderId: 2,
//       message:
//         "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim.",
//       timestamp: "2024-07-05T17:58:00Z",
//     },
//   ];

//   // Group chats by date but keep the full timestamp
//   const groupChatsByDate = () => {
//     const groupedChats = {};

//     chats.forEach((chat) => {
//       const date = dayjs(chat.timestamp).format("YYYY-MM-DD");
//       if (!groupedChats[date]) {
//         groupedChats[date] = [];
//       }
//       groupedChats[date].push(chat);
//     });

//     // Convert to array of date objects with the first message's full timestamp
//     return Object.keys(groupedChats)
//       .sort((a, b) => dayjs(a).diff(dayjs(b)))
//       .map((date) => {
//         // Get the first message's full timestamp for each date group
//         const fullTimestamp = groupedChats[date][0].timestamp;
//         return {
//           timestamp: fullTimestamp, // Use the full ISO timestamp
//           messages: groupedChats[date],
//         };
//       });
//   };

//   const chatsByDate = groupChatsByDate();

//   // Add useEffect to scroll to the bottom when component mounts or chats change
//   useEffect(() => {
//     if (chatContainerRef.current) {
//       chatContainerRef.current.scrollTop =
//         chatContainerRef.current.scrollHeight;
//     }
//   }, [chats]); // Dependency on chats ensures it scrolls when new messages are

//   return (
//     <div
//       className="flex flex-col gap-5 p-4 overflow-auto h-full"
//       ref={chatContainerRef}
//     >
//       {chatsByDate.map((dateGroup, index) => (
//         <div key={index} className="flex flex-col text-xs">
//           <div>
//             <Divider>{dateFormator(dateGroup.timestamp, "full")}</Divider>
//           </div>

//           <div className="flex flex-col gap-3">
//             {dateGroup.messages.map((chat) => {
//               const sender = users.find((user) => user.id === chat.senderId);

//               return (
//                 <div key={chat.id}>
//                   <Chat
//                     //key={chat.id}
//                     data={chat}
//                     sender={sender}
//                     loginUserId={loginUserId}
//                   />
//                 </div>
//               );
//             })}
//           </div>
//         </div>
//       ))}
//     </div>
//   );
// };

// export default ChatHistory;
